import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2529e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-availability-search__body-title" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "event-availability-search__body-title" }
const _hoisted_5 = {
  key: 0,
  class: "event-availability-search__body-title"
}
const _hoisted_6 = {
  key: 0,
  class: "event-availability-search__price event-availability-search__price--base event-availability-search__price--discounted"
}

import { computed, PropType, ref, watch } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import {
  EventInformation,
  MinimumTimeslot,
} from '@/models/public/service.model'
import BaseButton from '@/components/BaseButton.vue'
import isValid from 'date-fns/isValid'
import { getValidationErrorData } from '@/utils/errors'
import {
  createOrUpdateEventServiceOrderItem,
  useCreateOrderMutation,
  useFetchCartByUuid,
} from '@/queries/cart'
import { CreateEventServiceOrderItem, Order } from '@/models/public/order.model'
import EventSalesItems from '@/components/booking-widget/EventSalesItems.vue'
import DurationTag from '@/components/booking-widget/DurationTag.vue'
import { useFetchServiceEventInformationBookingWidgetMutation } from '@/queries/public/services'
import debounce from 'lodash/debounce'
import { isNumeric } from '@/utils/general'
import { formatCurrency } from '@/utils/formatters'
import { ALERT_TYPES } from '@/enums/components'
import parseISO from 'date-fns/parseISO'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventCard',
  props: {
  selectedService: {
    type: Object as PropType<PublicService>,
    required: true,
  },
  selectedStartDate: {
    type: Object as PropType<Date | null>,
    default: null,
  },
  selectedAdultCount: {
    type: Number,
    default: 1,
  },
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
  order: {
    type: Object as PropType<Order | null>,
    default: null,
  },
},
  emits: ["update:selectedStartDate", "update:selectedAdultCount", "update:order"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:selectedStartDate', newDate: Date): void
  (e: 'update:selectedAdultCount', newAdultCount: number): void
  (e: 'update:order', newOrder: Order): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const salesItemQuantities = ref<Record<string, number>>({})
const eventInfo = ref<EventInformation | undefined>(undefined)
const errors = ref<Record<string, string | undefined>>({})
const loading = ref<boolean>(false)
const debouncedUpdateEventInfo = debounce(updateEventInfo, 400)

const { mutateAsync: createOrder } = useCreateOrderMutation()
const { mutateAsync: fetchEventInfo } =
  useFetchServiceEventInformationBookingWidgetMutation(
    props.selectedService.hash_id,
  )
const { mutateAsync: fetchCart } = useFetchCartByUuid()

const isDiscounted = computed<boolean>(
  () => eventInfo.value?.base_total !== eventInfo.value?.discounted_total,
)

const isCancelled = computed<boolean>(() => {
  return !!eventInfo.value?.cancelled_at
})

const isSalesEnded = computed<boolean>(() => {
  if (!eventInfo.value?.sale_ends_at) {
    return false
  }
  const saleEndsAt = parseISO(eventInfo.value?.sale_ends_at)
  const currentMoment = new Date()
  return currentMoment > saleEndsAt
})

const hasPrice = computed<boolean>(
  () =>
    !!eventInfo.value &&
    (eventInfo.value.base_total !== '0.00' ||
      eventInfo.value.discounted_total !== '0.00'),
)

const formattedBasePrice = computed<string>(() =>
  isNumeric(eventInfo.value?.base_total)
    ? formatCurrency(eventInfo.value?.base_total)
    : '- €',
)

const formattedDiscountedPrice = computed<string>(() =>
  isNumeric(eventInfo.value?.discounted_total)
    ? formatCurrency(eventInfo.value?.discounted_total)
    : '- €',
)

watch(
  () => props.selectedService,
  () => {
    errors.value = {}
  },
)

watch(
  () => [salesItemQuantities.value, props.selectedSlots],
  () => {
    debouncedUpdateEventInfo(props.selectedSlots[0]?.id)
  },
)

async function updateEventInfo(eventId?: number) {
  try {
    if (eventId) {
      eventInfo.value = await fetchEventInfo({
        eventId,
        sales_items: salesItemQuantities.value,
      })
    }
  } catch (error) {
    // @ts-ignore
    errors.value = getValidationErrorData(error)
  }
}

const addEventServiceItemToCart = async () => {
  loading.value = true
  if (errors.value.order) {
    delete errors.value.order
  }
  let orderUuid = props.order?.uuid
  const payload: CreateEventServiceOrderItem = {
    service: props.selectedService.id,
    sales_items: salesItemQuantities.value,
    event: props.selectedSlots[0].id as number,
    additional_services: {},
    requests: '',
    referral_type: '',
    referral_code: '',
    item_group: null,
  }
  try {
    if (!orderUuid) {
      const order = await createOrder()
      if (order) {
        orderUuid = order.uuid
      }
    }
    if (orderUuid) {
      await createOrUpdateEventServiceOrderItem(orderUuid, payload)
      const updatedOrderData = await fetchCart(orderUuid)
      emit('update:order', updatedOrderData)
    }
  } catch (error: unknown) {
    // @ts-ignore
    errors.value.order = getValidationErrorData(error)
  }
  loading.value = false
}

const handleBuy = async () => {
  if (props.order?.uuid) {
    window.open(window.location.origin + '/order/' + props.order.uuid)
  }
}

function updateDate(newDate: Date) {
  if (!isValid(newDate)) return

  emit('update:selectedStartDate', newDate)
}

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t('whenAreYouGoing')), 1),
    _createVNode(_component_DatePicker, {
      name: "arrival",
      "model-value": __props.selectedStartDate,
      label: _ctx.$t('arrival'),
      errors: [
      errors.value?.arrival,
      errors.value?.consecutive,
      errors.value?.minDuration,
      errors.value?.maxDuration,
    ],
      "onUpdate:modelValue": updateDate
    }, null, 8, ["model-value", "label", "errors"]),
    (!errors.value?.arrival)
      ? (_openBlock(), _createBlock(DurationTag, {
          key: 0,
          "selected-slots": __props.selectedSlots
        }, null, 8, ["selected-slots"]))
      : _createCommentVNode("", true),
    (_unref(isCancelled))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AlertBanner, {
            text: _ctx.$t('eventService.eventIsCancelled'),
            "alert-type": _unref(ALERT_TYPES).INFO
          }, null, 8, ["text", "alert-type"])
        ]))
      : (_unref(isSalesEnded))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_AlertBanner, {
              text: _ctx.$t('eventService.eventSalesEnded'),
              "alert-type": _unref(ALERT_TYPES).INFO
            }, null, 8, ["text", "alert-type"])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('howManyAreYou')), 1),
            _createVNode(EventSalesItems, {
              "sales-item-quantities": salesItemQuantities.value,
              "onUpdate:sales-item-quantities": _cache[0] || (_cache[0] = ($event: any) => ((salesItemQuantities).value = $event)),
              "selected-service": __props.selectedService,
              "selected-slots": __props.selectedSlots,
              errors: errors.value,
              "event-info": eventInfo.value
            }, null, 8, ["sales-item-quantities", "selected-service", "selected-slots", "errors", "event-info"]),
            (_unref(hasPrice))
              ? (_openBlock(), _createElementBlock("h4", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.$t('price.priceLabel')) + " ", 1),
                  (_unref(isDiscounted))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(formattedBasePrice)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["event-availability-search__price", [
          _unref(isDiscounted) && 'event-availability-search__price--discounted',
        ]])
                  }, _toDisplayString(_unref(formattedDiscountedPrice)), 3)
                ]))
              : _createCommentVNode("", true)
          ], 64)),
    _createVNode(BaseButton, {
      loading: loading.value,
      disabled: 
      !_unref(hasPrice) || Object.keys(errors.value).length || _unref(isCancelled) || _unref(isSalesEnded)
    ,
      onOnClick: addEventServiceItemToCart
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('bookingWidget.addToCart')), 1)
      ]),
      _: 1
    }, 8, ["loading", "disabled"]),
    _createVNode(BaseButton, {
      class: "event-availability-search__button",
      loading: loading.value,
      disabled: !__props.order,
      onOnClick: handleBuy
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('bookingWidget.goToBuy')), 1)
      ]),
      _: 1
    }, 8, ["loading", "disabled"])
  ], 64))
}
}

})